import SpeakerFormat from './SpeakerFormat';
import SpeakerFrequency from './SpeakerFrequency';
import * as S from './styles';

export interface SpeakerLabelFormattingProps {}

const SpeakerLabelFormatting: React.FC<SpeakerLabelFormattingProps> = () => {
  return (
    <S.Contents>
      <SpeakerFormat />

      <SpeakerFrequency />
    </S.Contents>
  );
};

export default SpeakerLabelFormatting;
